import React, { useState } from 'react';
import PropTypes from 'prop-types';

import ProductPackage from '../reusable/ProductPackage';

/**
 * CordellEstimatorProductPackage.
 * Page for product.
 *
 * @author  Manny
 * @param   {Object}      props.coupon          Coupon object.
 * @param   {Function}    props.onSelectPackage Handles onClick for selecting a package.
 * @param   {Number}      props.productId       Id number of the product.
 * @param   {Object}      props.productsConfig  Product configurations.
 * @returns {JSX.Element} The component markup.
 */

const CordellEstimatorProductPackage = ({ coupon, onSelectPackage, productId, productsConfig }) => {
  const [activeKey, setActiveKey] = useState(
    productsConfig ? Object.keys(productsConfig.packages).length.toString() : ''
  );
  const [packageKey, setPackageKey] = useState(
    productsConfig
      ? Object.keys(productsConfig.packages)[Object.keys(productsConfig.packages).length - 1]
      : ''
  );

  const productPackage = {
    contactText: 'Request Pricing',
    contactUrl: 'https://www.cotality.com/au/products/cordell-estimator#rc-form',
    packageHeader: 'Cordell Estimator - AU Costings Data',
    packageTitle: 'Cordell Estimator Premium',
    packageTexts: ['Learn more about Cordell Estimator Premium with national data access.'],
    productId: productId,
    productName: 'cordellEstimator',
  };

  return (
    <ProductPackage
      activeKey={activeKey}
      coupon={coupon}
      onSelectPackage={onSelectPackage}
      packageKey={packageKey}
      productPackage={productPackage}
      productsConfig={productsConfig}
      setActiveKey={setActiveKey}
      setPackageKey={setPackageKey}
    />
  );
};

CordellEstimatorProductPackage.propTypes = {
  coupon: PropTypes.object,
  onSelectPackage: PropTypes.func.isRequired,
  productId: PropTypes.number,
  productsConfig: PropTypes.object
};

export default CordellEstimatorProductPackage;
